module.exports = __webpack_public_path__ + "img/202509-2_07.d8351399.jpg";